import { useState, useEffect, useMemo } from 'react';
import { Generals } from '../../enums/general.names.enum';
import './style.css';
import GroupManagement from './groupManagement';
import TeamManagement from '../TeamManagement/team_management.component';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';

export const LandingPageUserManagement = () => {
  const navigate = useNavigate();
  const permissionsJSON = localStorage.getItem('permissions');
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];

  // Check permissions for each tab
  const hasUserManagementAccess = permissionNames.includes('User Management');
  const hasTeamManagementAccess = permissionNames.includes('Team Management');

  // Determine available tabs and their values
  const availableTabs = useMemo(() => {
    const tabs = [];
    if (hasUserManagementAccess) {
      tabs.push({ value: 1, name: 'Users', tabName: Generals.user });
      tabs.push({ value: 3, name: 'Permissions', tabName: Generals.permission });
    }
    if (hasTeamManagementAccess) {
      tabs.push({ value: 4, name: 'Team Management', tabName: Generals.team });
    }
    return tabs;
  }, [hasUserManagementAccess, hasTeamManagementAccess]);

  // Get the first available tab value
  const firstAvailableTab = availableTabs.length > 0 ? availableTabs[0].value : null;

  const [value, setValue] = useState(firstAvailableTab || 1);
  const [controllerTab, setControllerTab] = useState(
    availableTabs.length > 0 ? availableTabs[0].tabName : Generals.user
  );

  // Check if user has access to any of the Access Control modules
  useEffect(() => {
    const hasNoAccessControlAccess = !hasUserManagementAccess && !hasTeamManagementAccess;
    if (hasNoAccessControlAccess) {
      navigate('/rov');
    }
  }, [hasUserManagementAccess, hasTeamManagementAccess, navigate]);

  // Ensure the selected tab is valid based on permissions
  useEffect(() => {
    const currentTabExists = availableTabs.some((tab) => tab.value === value);
    if (!currentTabExists && firstAvailableTab !== null) {
      const firstTab = availableTabs[0];
      setValue(firstTab.value);
      setControllerTab(firstTab.tabName);
    }
  }, [value, availableTabs, firstAvailableTab]);

  const handleChange = (event, tabName) => {
    setValue(Number(event.target.value));
    setControllerTab(tabName);
  };

  return (
    <>
      <DashboardLayout padding={true}>
        {/* Users Tab - Only show if user has User Management access */}
        {hasUserManagementAccess && (
          <>
            <input
              type="radio"
              name="tabset"
              id="tab1"
              aria-controls="marzen"
              value={1}
              checked={value === 1}
              onChange={(e) => handleChange(e, Generals.user)}
            />
            <label htmlFor="tab1" style={{ marginLeft: '20px' }}>
              Users
            </label>
          </>
        )}
        {/* Permissions Tab - Only show if user has User Management access */}
        {hasUserManagementAccess && (
          <>
            <input
              type="radio"
              name="tabset"
              id="tab3"
              aria-controls="dunkles"
              value={3}
              checked={value === 3}
              onChange={(e) => handleChange(e, Generals.permission)}
            />
            <label htmlFor="tab3">Permissions</label>
          </>
        )}
        {/* Team Management Tab - Only show if user has Team Management access */}
        {hasTeamManagementAccess && (
          <>
            <input
              type="radio"
              name="tabset"
              id="tab4"
              aria-controls="team"
              value={4}
              checked={value === 4}
              onChange={(e) => handleChange(e, Generals.team)}
            />
            <label htmlFor="tab4">Team Management</label>
          </>
        )}
        <div className="tab-panels">
          {/* Users Panel - Only render if user has User Management access */}
          {hasUserManagementAccess && (
            <section
              id="marzen"
              className={`tab-panel ${value === 1 ? 'visible' : 'hidden'}`}
              style={{ paddingLeft: '32px' }}
            >
              {value === 1 ? <GroupManagement control={controllerTab} /> : null}
              <p></p>
            </section>
          )}
          {/* Permissions Panel - Only render if user has User Management access */}
          {hasUserManagementAccess && (
            <section
              id="dunkles"
              className={`tab-panel ${value === 3 ? 'visible' : 'hidden'}`}
              style={{ paddingLeft: '32px' }}
            >
              {value === 3 ? <GroupManagement control={controllerTab} /> : null}
              <p></p>
            </section>
          )}
          {/* Team Management Panel - Only render if user has Team Management access */}
          {hasTeamManagementAccess && (
            <section
              id="team"
              className={`tab-panel ${value === 4 ? 'visible' : 'hidden'}`}
              style={{ padding: '0px' }}
            >
              {value === 4 ? <TeamManagement /> : null}
              <p></p>
            </section>
          )}
        </div>
      </DashboardLayout>
    </>
  );
};
